import Vue from 'vue';

Vue.component('attendant-tagging-index', () =>
    import(/* webpackChunkName: 'attendant-tagging-index' */ './attendant-tagging-index.vue'),
);
